import { services } from '../services';

export const useServices = () => {
    return services;
};
